/*
 * @Author: Yun
 * @Date: 2023-11-29 12:44:29
 * @Last Modified by: Yun
 * @Last Modified time: 2023-12-28 12:48:03
 */
import React, { useEffect, useState, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import Loading from '@components/loading'
import FirstPage from '@components/pc/firstPage'
import SecondPage from '@components/pc/secondPage'
import NewDemo from '@components/pc/NewDemo'
import SwiperDemoPage from '@components/pc/SwiperDemoPage'
import FourthPage from '@components/pc/fourthPage'
import Greetings from '@components/pc/greetings'
import BottomPage from '@components/pc/bottomPage'
import './index.less'
const PREFIX = 'china23-pc'
// if (window.history.scrollRestoration) {
//     window.history.scrollRestoration = 'manual'
// }
const PcPage = (props) => {
    const [swiperPageIndex, setSwiperPageIndex] = useState(0)
    const childRef = useRef()

    useEffect(() => {
        console.log(window.jwplayer('greetings_video'))
    })

    const callChildMethod = () => {
        if (childRef.current) {
            childRef.current.childMethod()
        }
    }
    const setSwiperPageCurrentIndex = (e) => {
        setSwiperPageIndex(e)
    }

    const closeSecondPageVideo = () => {
        window.jwplayer('second_page_video').pause()
    }
    const closeGreetingsPageVideo = () => {
        window.jwplayer('greetings_video').pause()
    }

    const closeSwiperPageVideoForSencondPage = () => {
        console.log(swiperPageIndex)
        window.jwplayer('page-1-video').pause()
        window.jwplayer('page-2-video').pause()
        window.jwplayer('page-3-video').pause()
        window.jwplayer('page-4-video').pause()
        window.jwplayer('page-5-video').pause()
        window.jwplayer('page-6-video').pause()
        if (swiperPageIndex === 4) {
            window.jwplayer('page-7-video').pause()
        }
    }
    const closeSwiperPageVideoForSwiperPage = () => {
        window.jwplayer('page-1-video').pause()
        window.jwplayer('page-2-video').pause()
        window.jwplayer('page-3-video').pause()
        window.jwplayer('page-4-video').pause()
        window.jwplayer('page-5-video').pause()
        window.jwplayer('page-6-video').pause()
    }
    return (
        <div className={PREFIX}>
            <div className={`${PREFIX}-wrapper`}>
                <NewDemo />
                <SecondPage
                    closeSwiperPageVideo={closeSwiperPageVideoForSencondPage}
                    closeGreetingsPageVideo={closeGreetingsPageVideo}
                    closeAudio={callChildMethod}
                />
                <FirstPage />
                <SwiperDemoPage
                    closeSecondPageVideo={closeSecondPageVideo}
                    closeGreetingsPageVideo={closeGreetingsPageVideo}
                    setSwiperPageCurrentIndex={setSwiperPageCurrentIndex}
                    closeSwiperPageVideo={closeSwiperPageVideoForSwiperPage}
                    ref={childRef}
                />
                <Greetings
                    closeSwiperPageVideo={closeSwiperPageVideoForSencondPage}
                    closeAudio={callChildMethod}
                    closeSecondPageVideo={closeSecondPageVideo}
                />
                <FourthPage />
                <BottomPage />
            </div>
        </div>
    )
}

export default PcPage
